import { Link } from "react-router-dom";

export default function UIMainLogo() {
    return (
        <Link to="/">
            <img src="/assets/logo/logo_cardif.svg" alt="Logo" className="w-[151px] h-[28px] max-w-none" />
        </Link>
    )
}